import React from 'react';
import { Typography as MuiTypography, TypographyProps } from '@mui/material';


export interface ITypographyProps extends TypographyProps{
  children: React.ReactNode;
}

//example <Typograpy variant={variant}></Typograpy>

const Typography = ({children,...rest}:ITypographyProps) => {
    
  return <MuiTypography {...rest}>{children}</MuiTypography>;
}



export default Typography;